import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TagCatalogApi, TagCatalogComponent } from 'src/app/components/tag-catalog/tag-catalog.component';
import { SocietyService } from 'src/app/services/society.service';

/**
 * Admin ▸ Gesellschaften: the Portfoliozuordnungen (Eigenbestand, Teil-PVA, …) a Gesellschaft can
 * have; the org chart groups the Gesellschaften by them. Same catalog UI as Admin ▸ Tags.
 */
@Component({
  selector: 'app-config-society-sales-models-page',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TagCatalogComponent],
  template: `<app-tag-catalog
    [api]="api"
    [heading]="heading"
    [description]="description"
    [namePlaceholder]="namePlaceholder"
    [duplicateMessage]="duplicateMessage"
    [emptyText]="emptyText"
    [deleteTitle]="deleteTitle"
    [deleteQuestion]="deleteQuestion"
  ></app-tag-catalog>`,
})
export class ConfigSocietySalesModelsPageComponent {
  readonly heading = $localize`:@@societySalesModels:Portfolio assignments`;
  readonly description = $localize`:@@societySalesModelsDescription:Define the portfolios a company can be assigned to. The org chart groups the companies by them.`;
  readonly namePlaceholder = $localize`:@@societySalesModelNamePlaceholder:Enter portfolio assignment`;
  readonly duplicateMessage = $localize`:@@salesModelExists:Portfolio assignment already exists`;
  readonly emptyText = $localize`:@@noSalesModelsYet:No portfolio assignments yet. Use "Add" to create the first one.`;
  readonly deleteTitle = $localize`:@@deleteSalesModelTitle:Delete portfolio assignment`;
  readonly deleteQuestion = (name: string) =>
    $localize`:@@deleteSalesModelConfirm:Are you sure you want to delete the portfolio assignment <b>${name}:name:</b>? Companies assigned to it will no longer have one.`;

  readonly api: TagCatalogApi = {
    load: async () => {
      const result = await this.societyService.getSalesModels();
      return { ...result, tags: (result.salesModels ?? []).map(m => ({ id: m.id, name: m.name })) };
    },
    save: (id, name) => this.societyService.saveSalesModel({ id: id ?? 0, name }),
    remove: tag => this.societyService.deleteSalesModel(tag.id),
  };

  constructor(private societyService: SocietyService) {}
}
